import { atom } from 'jotai';

export type FilterValuesConfig = {
  /** Attribute group ID used as parentId in getFilterChildValues (e.g. 'A0006') */
  parentId: string;
  /** Human-readable parent group name (e.g. 'Site Attributes') */
  parent: string;
  /** Human-readable child name (e.g. 'Site') */
  child: string;
};

export type DynamicFilterConfig = {
  filterType: 'leader' | 'site' | 'jobCode' | (string & {});
  attrId: string | string[];
  required: boolean;
  label?: string;
  storageKey?: string;
  /**
   * When true, this filter participates in bidirectional cascading:
   * - its available options are narrowed by all other currently-selected cascading filters
   * - its own selection narrows the options of every other cascading filter
   * Defaults to false for backward compatibility.
   */
  cascades?: boolean;
  /**
   * Configuration for fetching the full list of available values via
   * getFilterChildValues. Required when filterType === 'site' (or any filter
   * type that needs a domain-aware attribute value lookup).
   */
  filterValuesConfig?: FilterValuesConfig;
};

export interface DynamicModalStateReportProp {
  name?: string;
  domains?: string[];
  id?: string;
}

type Props = {
  report: DynamicModalStateReportProp | null;
  isOpen: boolean;
  hasApplied: boolean; // replaces hasSelectedLeader
  selectionMap: Record<string, string[]>; // keyed by filterType
  /** The resolved filter configs for the current report group, used by useFetchRawReport */
  resolvedFilterConfigs?: DynamicFilterConfig[];
};

export const dynamicModalState = atom<Props>({
  isOpen: false,
  report: null,
  hasApplied: false,
  selectionMap: {},
  resolvedFilterConfigs: undefined,
});
